import { SceneToken } from "../enums/scene-token.enum";
import { DisplayConfig } from "../interfaces/display-config.interface";
import { IDisplayState } from "../interfaces/display-state.interface";

export const displayConfig = (): Partial<Record<keyof IDisplayState, DisplayConfig[]>> => ({
  expert: [
    { token: SceneToken.START_PAGE, active: false },
    { token: SceneToken.QUESTION, active: true },
    { token: SceneToken.FORM, active: true },
    { token: SceneToken.RESULT, active: true },
    { token: SceneToken.FINAL, active: false },
    { token: SceneToken.SIGN_UP, active: false }
  ],

  progressBar: [
    { token: SceneToken.START_PAGE, active: false },
    { token: SceneToken.QUESTION, active: true },
    { token: SceneToken.FORM, active: true },
    { token: SceneToken.RESULT, active: true },
    { token: SceneToken.FINAL, active: true },
    { token: SceneToken.SIGN_UP, active: false }
  ],

  buttonBack: [
    { token: SceneToken.START_PAGE, active: false },
    { token: SceneToken.QUESTION, active: true },
    { token: SceneToken.FORM, active: false },
    { token: SceneToken.RESULT, active: false },
    { token: SceneToken.FINAL, active: false },
    { token: SceneToken.SIGN_UP, active: true }
  ],

  label: [
    { token: SceneToken.START_PAGE, active: true },
    { token: SceneToken.QUESTION, active: true },
    { token: SceneToken.FORM, active: false },
    { token: SceneToken.RESULT, active: true },
    { token: SceneToken.FINAL, active: true },
    { token: SceneToken.SIGN_UP, active: true }
  ],

  infoBlock: [
    { token: SceneToken.START_PAGE, active: false },
    { token: SceneToken.QUESTION, active: true },
    { token: SceneToken.FORM, active: true },
    { token: SceneToken.RESULT, active: true },
    { token: SceneToken.FINAL, active: true },
    { token: SceneToken.SIGN_UP, active: false }
  ]
})